export const videoTextList = [
  'Filipino (Filipino)',
  '한국어 (Korean)',
  'English (English)',
  '日本語 (Japanese)',
  'français (French)',
  'Español (Spanish)',
  'ภาษาไทย (Thai)',
  'Tiếng Việt (Vietnamese)',
  'Bahasa Indonesia (Indonesian)',
  '中文 (Chinese)',
]
export const langList = [
  { name: '中文 (Chinese)', value: 'zh' },
  { name: 'English (English)', value: 'en' },
  { name: 'Filipino (Filipino)', value: 'fil' },
  { name: 'français (French)', value: 'fr' },
  { name: 'Bahasa Indonesia (Indonesian)', value: 'id' },
  { name: '日本語 (Japanese)', value: 'ja' },
  { name: '한국어 (Korean)', value: 'ko' },
  { name: 'Español (Spanish)', value: 'es' },
  { name: 'ภาษาไทย (Thai)', value: 'th' },
  { name: 'Tiếng Việt (Vietnamese)', value: 'vi' },
]
